import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "label", "icon", "isDisabled", "isSuccess", "link", "route", "routeParams", "target", "onClick", "iconRight", "title", "variant", "isRequired", "type", "classes"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable complexity */
import React, { useEffect, useMemo, useState } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import A from '../A';
import Icon from '../Icon';
import withMemo from '../../decorators/withMemo';
import { mergeStyles } from '../../utils/StyleUtils';
import styles from './styles';
var useStyles = createUseStyles(styles);
var ActionButton = function ActionButton(props) {
  var className = props.className,
    label = props.label,
    icon = props.icon,
    isDisabled = props.isDisabled,
    isSuccess = props.isSuccess,
    link = props.link,
    route = props.route,
    routeParams = props.routeParams,
    target = props.target,
    onClick = props.onClick,
    iconRight = props.iconRight,
    title = props.title,
    variant = props.variant,
    isRequired = props.isRequired,
    type = props.type,
    classesProp = props.classes,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasHover = _useState2[0],
    setHasHover = _useState2[1];
  useEffect(function () {
    setHasHover(!('ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0));
  }, []);
  var classesComp = useStyles(_objectSpread(_objectSpread({}, props), {}, {
    hasHover: hasHover
  }));
  var classes = useMemo(function () {
    return mergeStyles(classesComp, classesProp);
  }, [classesProp, classesComp]);

  // to compensate for JSS failure
  var isDisabledClass = isDisabled === true ? classes.containerDisabled : null;
  var isVariantClass = variant === 'transparent' ? classes.containerTransparent : classes.containerDefault;
  var iconRightClass = iconRight ? classes.iconRight : null;
  var renderIcon = icon && /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    className: classes.icon,
    color: "currentColor",
    iconClassName: classes.iconAsset
  });
  var content = /*#__PURE__*/React.createElement(React.Fragment, null, icon && renderIcon, label);
  var renderSubmit = /*#__PURE__*/React.createElement("button", _extends({
    type: "submit"
  }, otherProps, {
    className: cx(classes.container, className, iconRightClass, isVariantClass, isDisabledClass),
    onClick: onClick
  }), content);
  var renderDefault = /*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
    className: cx(classes.container, className, iconRightClass, isVariantClass, isDisabledClass),
    onClick: !isDisabled ? onClick : null,
    role: "presentation"
  }), content, isRequired && /*#__PURE__*/React.createElement("span", {
    className: classes.spark
  }, "*"));
  var renderAsLink = /*#__PURE__*/React.createElement(A, _extends({}, otherProps, {
    href: link,
    route: route,
    routeParams: routeParams,
    target: target,
    title: title || label,
    className: cx(classes.container, className, iconRightClass, isVariantClass, isDisabledClass)
  }), content, isRequired && /*#__PURE__*/React.createElement("span", {
    className: classes.spark
  }, "*"));
  return type === 'submit' ? renderSubmit : !isDisabled && !isSuccess && (link || route) ? renderAsLink : renderDefault;
};
ActionButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string),
  label: PropTypes.string,
  icon: PropTypes.func,
  variant: PropTypes.oneOf(['default', 'transparent']),
  isDisabled: PropTypes.bool,
  isSuccess: PropTypes.bool,
  link: PropTypes.string,
  route: PropTypes.string,
  routeParams: PropTypes.shape({
    slug: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)])
  }),
  target: PropTypes.string,
  onClick: PropTypes.func,
  iconRight: PropTypes.bool,
  title: PropTypes.string,
  isRequired: PropTypes.bool,
  type: PropTypes.oneOf(['submit', 'button'])
};
ActionButton.defaultProps = {
  className: '',
  classes: {},
  label: '',
  icon: null,
  variant: 'default',
  isDisabled: false,
  isSuccess: false,
  link: null,
  route: null,
  routeParams: null,
  target: null,
  onClick: function onClick() {
    return null;
  },
  iconRight: false,
  title: null,
  isRequired: false,
  type: null
};
export default withMemo()(ActionButton);